import {IController, IModule, IScope} from "angular";
import {regNavn} from "../../tjenester/tredjepartsTjenestenavn";
import {Debugger} from "debug";
import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import {Datoformatering} from "../../tjenester/Datoformatering";

const debug: Debugger = require('debug')('DatoPeriodeFormateringKontroller');
const css = require('./datoperiodeFormatering.scss');


export class DatoPeriodeFormateringKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('datoperiodeFormatering', {
                bindings: {
                    period: '<',
                    format: '@'
                },
                controller: DatoPeriodeFormateringKontroller.forInjisering(),
                template: require('./datoperiodeFormatering.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            Datoformatering.regNavn,
            DatoPeriodeFormateringKontroller
        ]
    }

    constructor(private $scope: IScope, private datoformatering: Datoformatering) {
    }

    period: l.DatoPeriode; //settes via bindings/$onChanges
    format: 'kortUtenKlokkeslett'; //settes via bindings

    formatert: string;

    $onInit(): void {
        //bruker watch fremfor $onChanges da vi må reagere på endringer inne i this.periode, ikke kun på at this.periode instansen endres
        this.$scope.$watchCollection(() => [this.period?.start, this.period?.slutt], () => {
            this.setFormatertPeriode();
        });
    }

    //hjelpemetoder

    private setFormatertPeriode() {
        switch (this.format) {
            case "kortUtenKlokkeslett":
                this.formaterKortUtenKlokkeslett();
                break;
            default:
                throw new Error(`ikke-implementert format ${this.format} angitt`)
        }
    }

    private formaterKortUtenKlokkeslett() {
        this.formatert = this.datoformatering.somAbsoluttPeriodeUtenKlokkeslett(this.period?.start, this.period?.slutt)
    }
}

